import React from 'react';

interface AppLogoProps {
  size?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

export default function AppLogo({ size = 36, className, style }: AppLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ flexShrink: 0, display: 'inline-block', verticalAlign: 'middle', ...style }}
    >
      <defs>
        <linearGradient id="epLogoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#10B981" />
          <stop offset="50%" stopColor="#059669" />
          <stop offset="100%" stopColor="#047857" />
        </linearGradient>
      </defs>

      {/* Main Green Rounded Square */}
      <rect x="2" y="2" width="84" height="84" rx="24" fill="url(#epLogoGrad)" />

      {/* Bold White Text "АП" */}
      <text
        x="43"
        y="59"
        textAnchor="middle"
        fill="#FFFFFF"
        fontFamily="Outfit, 'Segoe UI', system-ui, -apple-system, sans-serif"
        fontWeight="800"
        fontSize="44"
        letterSpacing="-1.5"
      >
        АП
      </text>

      {/* Speech bubble badge at bottom right */}
      <g transform="translate(55, 53)">
        {/* White speech bubble container with yellow/amber border */}
        <path
          d="M 21 3 C 30.94 3 39 11.06 39 21 C 39 30.94 30.94 39 21 39 C 17.5 39 14.2 38 11.4 36.3 L 3 39.5 L 5.5 31.3 C 3.2 28.3 1.8 24.8 1.8 21 C 1.8 11.06 9.86 3 21 3 Z"
          fill="#FFFFFF"
          stroke="#F59E0B"
          strokeWidth="4.5"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        {/* Play triangle inside badge */}
        <path
          d="M 17 14 L 28 21 L 17 28 Z"
          fill="#F59E0B"
          stroke="#F59E0B"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
